import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const FrameIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M8.71851 14.1263V3.75976C8.52201 3.63226 8.39076 3.39526 8.39076 3.12376C8.39076 2.71876 8.68401 2.39026 9.04626 2.39026C9.40926 2.39026 9.70326 2.71876 9.70326 3.12376C9.70326 3.39526 9.57126 3.63226 9.37476 3.75976V5.87697L11.6677 4.23375C11.7362 4.18376 11.8216 4.16274 11.9055 4.17525L17.178 4.959C17.3527 4.98525 17.4817 5.151 17.4817 5.3475V7.89225C17.4817 8.08875 17.352 8.25525 17.1765 8.28075L11.904 9.06675C11.8273 9.07764 11.7493 9.06061 11.6842 9.01875L9.37476 7.54718V14.1263H11.6713C11.8528 14.1263 11.9998 14.2898 11.9998 14.4923C11.9998 14.6948 11.852 14.8598 11.672 14.8598H6.42201C6.24051 14.8598 6.09351 14.6963 6.09351 14.4938C6.09351 14.2898 6.24126 14.1263 6.42126 14.1263H8.71851ZM9.37476 6.71978C9.4417 6.7147 9.5108 6.73092 9.57371 6.771L11.9362 8.277L12.4211 8.20434V5.04287L11.9377 4.971L11.9355 4.96875L9.58646 6.65475C9.52111 6.70173 9.44693 6.72138 9.37476 6.71643V6.71978ZM14.5395 7.88691L13.2656 8.0778V5.16841L14.5391 5.35771C14.5337 5.38109 14.5309 5.40527 14.5309 5.43V7.81275C14.5309 7.83815 14.5339 7.86295 14.5395 7.88691ZM15.3746 7.76177V5.48191L16.7812 5.691V7.551L15.3746 7.76177Z'
                fill='currentColor'
            />
            <Path
                d='M7.43098 21.75H8.15698L9.56098 17.55H8.82898L7.81498 20.964L6.79498 17.55L6.09898 17.556L5.08498 20.964L4.06498 17.55H3.30298L4.69498 21.75H5.42698L6.43498 18.474L7.43098 21.75Z'
                fill='currentColor'
            />
            <Path d='M10.053 21.75H10.761V17.55H10.053V21.75Z' fill='currentColor' />
            <Path
                d='M14.811 21.75H15.507V17.55H14.811V20.568L12.561 17.55H11.865V21.75H12.573V18.738L14.811 21.75Z'
                fill='currentColor'
            />
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M18.339 17.55H16.617V21.75H18.321C19.593 21.75 20.511 20.862 20.511 19.65C20.511 18.432 19.599 17.55 18.339 17.55ZM17.325 21.114V18.186H18.327C19.155 18.186 19.797 18.798 19.797 19.656C19.797 20.508 19.173 21.114 18.357 21.114H17.325Z'
                fill='currentColor'
            />
        </>
    ),
})

FrameIcon.displayName = 'FrameIcon'
